import React, { FunctionComponent } from "react";
import { FormSection } from "../../../FormSection";
import { Box, Grid, MenuItem, SvgIcon } from "@mui/material";
import { CustomSelect } from "../../../CustomSelect";
import { DropdownValue } from "../../../../types/DropdownValue";
import { CustomInput } from "../../../CustomInput";
import { get24HourTime, list12Hours } from "../../../../utils/time";
import { CustomDatePicker } from "../../../CustomDatePicker";
import { SectionProps } from "../props";
import { mdiBriefcaseOutline, mdiClockOutline, mdiCurrencyUsd } from "@mdi/js";
import { Icon } from "@mdi/react";
import { User } from "../../../../model/User";

type LeadDetailState = {
  callStatus: string;
  product: string;
  apptDate: Date | undefined | null;
  apptTime: string;
  saleAmount: string;
  dropdownItems: DropdownValue[];
  dropdownProductItems: DropdownValue[];
  dropdownApptTimeRange: DropdownValue[];
};

export const LeadDetail: FunctionComponent<
  LeadDetailState & SectionProps & { onChangeDate: (newValue: any) => void }
> = (props) => {
  const user = new User();

  const showLeadOutcome = !user.HasForbiddenAccess("Can See Lead Outcome");
  const showProductInterest = !user.HasForbiddenAccess(
    "Can See Product Interest"
  );
  const showSaleAmount = !user.HasForbiddenAccess("Can See Sale Amount");
  const showLeadDetail =
    showLeadOutcome || showProductInterest || showSaleAmount;

  const editLeadOutcome = !user.HasForbiddenAccess("Can Edit Lead Outcome");
  const editProductInterest = !user.HasForbiddenAccess(
    "Can Edit Product Interest"
  );
  const editApptDate = !user.HasForbiddenAccess("Can Edit Appt Date");
  const editApptTime = !user.HasForbiddenAccess("Can Edit Appt Time");
  const editSaleAmount = !user.HasForbiddenAccess("Can Edit Sale Amount");

  const Appointment = () => {
    return (
      <Grid item>
        <Box display="flex" alignItems="center" gap={2}>
          <CustomDatePicker
            disabled={props.formDisabled || !editApptDate}
            name="apptDate"
            width={"100%"}
            label={{ text: "Appt Date" }}
            value={props.apptDate}
            onChange={props.onChangeDate}
          ></CustomDatePicker>
          <CustomSelect
            disabled={props.formDisabled || !editApptTime}
            MenuProps={{
              PaperProps: { sx: { maxHeight: 200 } },
            }}
            name="apptTime"
            value={props.apptTime}
            width="100%"
            label="Appt Time"
            StartIcon={
              <SvgIcon>
                <Icon path={mdiClockOutline} />
              </SvgIcon>
            }
            onChange={props.onChangeSelect}
          >
            {props.dropdownApptTimeRange.map((item, index) => {
              return (
                <MenuItem value={item.description}>{item.description}</MenuItem>
              );
            })}
          </CustomSelect>
        </Box>
      </Grid>
    );
  };

  return (
    <FormSection title="Lead Detail" isCollapsible>
      {showLeadOutcome && (
        <Grid item>
          <CustomSelect
            disabled={props.formDisabled || !editLeadOutcome}
            MenuProps={{ PaperProps: { sx: { maxHeight: 200 } } }}
            name="callStatus"
            label="Lead Outcome *"
            value={props.callStatus}
            onChange={props.onChangeSelect}
          >
            {props.dropdownItems.map((item, index) => {
              return (
                <MenuItem key={index} value={item.id}>
                  {item.description}
                </MenuItem>
              );
            })}
          </CustomSelect>
        </Grid>
      )}
      {showProductInterest && (
        <Grid item>
          <CustomSelect
            disabled={props.formDisabled || !editProductInterest}
            StartIcon={<Icon path={mdiBriefcaseOutline} />}
            name="product"
            label="Product Interest"
            value={props.product}
            onChange={props.onChangeSelect}
          >
            {props.dropdownProductItems.map((item, index) => {
              return (
                <MenuItem key={index} value={item.id}>
                  {item.description}
                </MenuItem>
              );
            })}
          </CustomSelect>
        </Grid>
      )}
      {props.callStatus === "8" && <Appointment />}
      {props.callStatus === "4" && <Appointment />}
      {props.callStatus === "5" && <Appointment />}
      {props.callStatus === "6" && <Appointment />}
      {props.callStatus === "7" && <Appointment />}
      {props.callStatus === "I" && <Appointment />}
      {showSaleAmount && (
        <Grid item>
          <CustomInput
            disabled={props.formDisabled || !editSaleAmount}
            value={props.saleAmount}
            onChange={props.onChange}
            name="saleAmount"
            startIcon={<Icon path={mdiCurrencyUsd} />}
            type="number"
            label={{
              text: "Sale Amount",
              color: "rgba(0, 0, 0, 0.8)",
            }}
            width={"100%"}
            height={35}
          />
        </Grid>
      )}
    </FormSection>
  );
};
